import React, { useState, useEffect } from "react";
import { useContext } from "../../../context";
import { SelectType } from "./shared/SelectType";
import { Header } from "./shared/Header";
import { AppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import EditorWithPreview from "../../../../../../../../Common/EditorWithPreview";
import { useCancelAppointment } from "../../../hooks/useCancelAppointment";
import { NOTIFICATION_TYPE } from "../../../config";
import { useCancelNotification } from "../../../hooks/useCancelNotification";

const DEFAULT_TYPE = NOTIFICATION_TYPE.emailAndSms;
const DEFAULT_BODY = "";

function ModalCancelNotification() {
  const {
    appointment,
    modals: {
      cancelNotification: { state, isOpen, close },
    },
  } = useContext();

  const cancel = useCancelAppointment();
  const notification = useCancelNotification();

  const [notificationType, setNotificationType] = useState(DEFAULT_TYPE);

  const [notificationBody, setNotificationBody] = useState(DEFAULT_BODY);
  useEffect(() => {
    !notificationBody &&
      notification &&
      setNotificationBody(notification.bodyEmail || "");
  }, [notificationBody, notification?.bodyEmail]);

  const onCancel = () => {
    if (!cancel.isLoading) {
      cancel.initiate({
        charge: state.charge,
        notificationType,
        notificationBody,
        isAdditionalProvider: state.isAdditionalProvider,
      });
    }
  };

  const onClose = () => {
    close();
    setNotificationType(DEFAULT_TYPE);
    setNotificationBody(DEFAULT_BODY);
  };

  return (
    <>
      {isOpen && (
        <div className="blackOverlay">
          <div className="vert-middle">
            <div className="loyaltyMembership start-program-main">
              <Header onClose={onClose} />
              <div className="newPopupContent">
                <div className="juvly-subtitle m-b-10">
                  {`Are you sure you want to cancel ${appointment.patient.fullName}'s appointment?`}
                  <br />
                  {`This appointment will be removed from your calendar and will appear as cancelled in ${appointment.patient.fullName}'s appointment history.`}
                </div>
                <SelectType
                  value={notificationType}
                  onChange={(value) => {
                    setNotificationType(value);
                    if (value === NOTIFICATION_TYPE.sms) {
                      setNotificationBody(notification.bodySms);
                    } else {
                      setNotificationBody(notification.bodyEmail);
                    }
                  }}
                />
                <p className="p-text">
                  Notification Message (optional)
                  <br />
                  <AppTranslation.Appointments path="appointmentTopNotification" />
                </p>
                <div className="newInputFileldOuter m-b-40">
                  <EditorWithPreview
                    placeholder="Email Body"
                    name="notificationBody"
                    value={notificationBody}
                    className="editor_textarea editor-preview"
                    handleEditorChange={({ notificationBody }) =>
                      setNotificationBody(notificationBody)
                    }
                  />
                </div>
              </div>
              <div>
                <button
                  onClick={onClose}
                  className="new-red-btn pull-left no-width"
                >
                  Back
                </button>
                <button
                  className="new-blue-btn pull-right"
                  onClick={onCancel}
                  disabled={cancel.isLoading}
                >
                  {cancel.isLoading ? "Canceling..." : "Cancel Appointment"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

ModalCancelNotification.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: ({ charge, isAdditionalProvider }) => {
      setState({
        charge,
        isAdditionalProvider,
      });
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalCancelNotification };
